import { Library, Eye } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useLibMode } from "@/hooks/useLibMode";
import { setLibMode } from "@/lib/api";

export const LibrarySwitch = () => {
  const { user } = useAuth();
  const mode = useLibMode();
  const share = user?.library_share;
  if (!share) return null;
  const btn = (m, label, Icon) => (
    <button onClick={() => setLibMode(m)} data-testid={`library-switch-${m}`}
      className={`flex items-center gap-2 rounded-full px-4 py-1.5 text-xs font-medium transition-colors ${mode === m ? "bg-zinc-900 text-white" : "text-zinc-600 hover:text-zinc-900"}`}>
      <Icon size={13} />{label}
    </button>
  );
  return (
    <div className="mb-8 flex flex-wrap items-center gap-3" data-testid="library-switch">
      <div className="flex rounded-full border border-zinc-200 bg-white p-1">
        {btn("mine", "My library", Library)}
        {btn("owner", `${share.owner_name}'s library`, Eye)}
      </div>
      {mode === "owner" && (
        <span className="font-mono text-[11px] text-zinc-500" data-testid="library-switch-access">
          {share.access === "download" ? "Listen + download" : "Listen only"}
        </span>
      )}
    </div>
  );
};

export const useOwnerView = () => {
  const { user } = useAuth();
  const mode = useLibMode();
  const share = user?.library_share;
  return { viewing: !!share && mode === "owner", canDownload: share?.access === "download" };
};
